import {useState} from "react";
import {bookingAPI} from "../common/api/bookingAPI";
import {API_BOOKING_REPLACE} from "../common/api/apiConstants";
import {useKeycloakFunctions} from "./useKeycloakFunctions";

export const useBookingReplace = () => {

    const {initialized, authenticated} = useKeycloakFunctions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const postBookingReplace = (bookings, reservationId, userDetails) => {

        if (initialized && authenticated) {
            setLoading(true);
            setError(null);

            const body = {
                new_reservation_id: reservationId,
                reservation_ids_to_cancel: bookings,
                ...userDetails
            };

            return bookingAPI.post(API_BOOKING_REPLACE, body)
                .then(res => {
                    setLoading(false);
                    return res;
                })
                .catch(err => {
                    setLoading(false);
                    setError(err?.response);
                    throw err.response;
                });
        }

    };

    return {
        postBookingReplace,
        loadingBookingReplace: loading,
        errorBookingReplace: error
    };
};
